import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  logoutInProgress: boolean = false;
  status: boolean = false;
  Roles: any;
  selectedOption: string = 'Java'; // Default selected option
  dropdownOptions: any[] = [
    { label: 'My Account', value: 'Java', disabled: true },
    // { label: 'Edit Profile', value: 'EditProfile' },
    { label: 'Change Password', value: 'changepassword' },
    { label: 'Logout', value: 'logout' }
  ];
  logout() {
    // remove user from local storage to log user out
    // localStorage.removeItem('Role');
    localStorage.clear();

    this.router.navigate(['/']);
  }
  clickEvent(){
      this.status = !this.status;       
  }
  constructor(private router: Router, 
    // private confirmationService: ConfirmationService
    ) { 
    this.Roles = localStorage.getItem('Role');
  }

  ngOnInit(): void {
  }
  isActive(route: string): boolean {
    return this.router.isActive(route, true);
  }
  filterDropdownOptions(): any[] {
    if (this.Roles === 'admin') {
      // Show all options for admin
      return this.dropdownOptions;
    } else {
      // Handle other roles here (if needed)
      return [];
    }
  }
  onDropdownChange(event: any) {
    const selectedValue = this.selectedOption;
    if (selectedValue === 'changepassword') {
      this.router.navigate(['admin/ChangePassword']);
    } 
    else if (selectedValue === 'logout') {
      console.log('logout')
      localStorage.clear();

      // this.Logout();
    } else {
    }
  }
  // Logout() {
  //   this.confirmationService.confirm({
  //     message: 'Are you sure that you want to log out?',
  //     accept: () => {
  //       localStorage.clear();
  //       this.router.navigate(['/']);
  //     },
  //     reject: () => {
  //       this.logoutInProgress = false; // Re-enable the dropdown
  //       this.selectedOption = 'Java';       }
  //   });
  // }
}


